// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"558a06c4","915":"1775289e"}[chunkId] + ".chunk.js";
};